/* global $ */
/**
 * Function to check slider has initialized, if not,
 * try initalize
 */
const initSlider = () => {
  const sections = document.querySelectorAll('.featured-collection-section');
  sections.forEach((section) => {
    const gallery = section.querySelector('.slider-gallery');
    /**
     *
     */
    const checkSliders = () => {
      if (!gallery.classList.contains('flickity-enabled')) {
        window.PXUTheme.jsFeaturedCollection.init($(section));
      } else {
        // eslint-disable-next-line no-use-before-define
        clearInterval(intervalID);
      }
    };
    const intervalID = setInterval(checkSliders, 1000);

    //
  });
};
document.addEventListener('DOMContentLoaded', () => {
  initSlider();
});
